export const parseIdsFromStrings = (idStrings: string[]) =>
  idStrings.map((idString) => parseInt(idString, 10)).filter((id) => !Number.isNaN(id));
